import Vue from 'vue'
import Vuex from 'vuex'
import modules from './modules'
Vue.use(Vuex)

const state = {
  // 市
  cityList: localStorage.getItem('cityList') ? localStorage.getItem('cityList') : null,
  // 省
  provinceList: localStorage.getItem('provinceList') ? localStorage.getItem('provinceList') : null,
  // 注册用户登录信息
  registeruser: localStorage.getItem('registeruser') ? localStorage.getItem('registeruser') : null,
  // 若localSorage存在token，将值赋给Vuex.state.token
  token: localStorage.getItem('token') ? localStorage.getItem('token') : null,
  // 菜单
  menuData: {
    list: [
      {
        index: 'order',
        label: '订单管理',
        url: '/order',
        icon: 'el-icon-s-order'
      }, {
        index: 'feedBack',
        label: '反馈管理',
        url: '/feedBack',
        icon: 'el-icon-s-comment'
      }, {
        index: 'monery',
        label: '资金管理',
        url: '/monery',
        icon: 'el-icon-s-claim'
      }, {
        index: 'userInfo',
        label: '用户信息',
        url: '/userInfo',
        icon: 'el-icon-s-custom'
      }, {
        index: 'couponManage',
        label: '优惠券管理',
        url: '/couponManage',
        icon: 'el-icon-s-cooperation'
      }, {
        index: 'borrowToolBox',
        label: '借用工具盒',
        url: '/borrowToolBox',
        icon: 'el-icon-s-grid'
      }, {
        index: 'doc',
        label: '使用说明书',
        url: '/doc',
        icon: 'el-icon-tickets'
      }, {
        index: 'registerManager',
        label: '邀请用户',
        url: '/registerManager',
        icon: 'el-icon-s-custom'
      }, {
        index: 'userOrder',
        label: '用户订单',
        url: '/userOrder',
        icon: 'el-icon-s-grid'
      }
    ],
    collapse: false
  }
}

const mutations = {
  // 切换菜单状态
  switchCollapseMenu (state, value) {
    if (value != null) {
      state.menuData.collapse = value
    } else {
      state.menuData.collapse = !state.menuData.collapse
    }
    window.localStorage.setItem('MENU_STATUS', state.menuData.collapse)
  },
  // 市
  setCityList (state, cityList) {
    state.cityList = cityList
    localStorage.setItem('cityList', JSON.stringify(cityList))
  },
  // 省
  setProvinceList (state, provinceList) {
    state.provinceList = provinceList
    localStorage.setItem('provinceList', JSON.stringify(provinceList))
  },
  // 设置已登录的用户信息
  setRegisterUserInfo (state, registeruser) {
    state.registeruser = registeruser
    localStorage.setItem('registeruser', JSON.stringify(registeruser))
  },
  setToken (state, token) {
    localStorage.setItem('token', token)

    const expirationDate = new Date().getTime() + 168 * 3600 * 1000 // 设置过期时间为7天
    localStorage.setItem('expirationDate', expirationDate)

    state.token = token
  },
  // 我页面中写了退出登录的按钮所以补了一个logout用来清空localStorage中的数据
  logout (state) {
    localStorage.removeItem('token')
    state.token = null
    localStorage.removeItem('registeruser')
    state.registeruser = null
    localStorage.removeItem('expirationDate')
    /* localStorage.removeItem('provinceList')
    state.provinceList = null
    localStorage.removeItem('cityList')
    state.cityList = null */
    // 我写的RSA加密需向后端获取公钥，为了方便我在拿到公钥后直接存入localStorage中，所以在这里也要清空
    // localStorage.removeItem('publickey')
    // state.publickey=null
  }
}
const actions = {}
const getters = {}
export default new Vuex.Store({
  modules,
  state,
  mutations,
  actions,
  getters
})



// WEBPACK FOOTER //
// ./src/store/index.js